import request from '@/utils/request'
//订单大厅
export function getOrderHall(data) {
  return request({
    url: '/driver_wy/hall',
    method: 'post',
    data
  })
}
//我的订单
export function getMyOrders(data) {
  return request({
    url: '/driver_wy/myOrder',
    method: 'post',
    data
  })
}
//订单详情
export function getOrderInfo(orderId) {
  return request({
    url: `/driver_wy/orderInfo/${orderId}`,
    method: 'get'
  })
}

//接受派单
export function agreePush(orderId) {
  return request({
    url: `/driver_wy/agreePush/${orderId}`,
    method: 'get'
  })
}

//抢单
export function robOrder(orderId) {
  return request({
    url: `/driver_wy/robOrder/${orderId}`,
    method: 'get'
  })
}

//上传照片
/**
 * 
 * @param {
 * order_id:订单id
 * status:状态:2=开始服务 3=交车
 * pic_path_num:编号,从1开始
 * file:文件
 * } data 
 * @returns 
*/
export function upOrderImage(data) {
  return request({
    url: '/driver_wy/upOrderImage',
    method: 'post',
    data
  })
}

//开始服务
/**
 * 
 * @param {
 * order_id:订单id
 * lng:经度
 * lat:纬度
 * content:备注
 * driver_city:0/2
 * start_mileage:起始里程表数字
 * } data 
 * @returns 
*/
export function startServer(data) {
  return request({
    url: '/driver_wy/startServer',
    method: 'post',
    data
  })
}

//获取订单图片
/**
 * 
 * @param {
 * order_id:订单id
 * status:状态:2=开始服务 3=交车
 * }
*/
export function orderImage(data) {
  return request({
    url: '/driver_wy/orderImage',
    method: 'post',
    data
  })
}

//结束服务
/**
 * 
 * @param {
 * order_id:订单id
 * lng:经度
 * lat:纬度
 * content:备注
 * driver_city:0/2
 * end_mileage:起始里程表数字
 * }
*/
export function doneServer(data) {
  return request({
    url: '/driver_wy/doneServer',
    method: 'post',
    data
  })
}

//签约
export function getSignUp(orderId) {
  return request({
    url: `/driver_wy/getSignUp`,
    method: 'get'
  })
}

//下载合同
export function hzqLinkFile(orderId) {
  return request({
    url: `/driver_wy/hzqLinkFile`,
    method: 'get'
  })
}